import { render } from "./Order.vue?vue&type=template&id=e4435de2&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=e4435de2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e4435de2"

export default script